import actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    email: "",
    firstname: "",
    lastname: "",
    fullName: "",
    error: null,
    userConfirmed: false,
    signupDone: false,
    showForgotPassword: true,
    showEmailSent: false,
    showGuidanceTooltip: false,
    fastspringAccountId: null,
    activeSubscription: null,
    accountManagementURL: null,
  },
  mutations,
  actions,
};
